<template>
  <b-modal
    ref="wizardWindow"
    no-close-on-backdrop
    size="xl"
    @shown="onShown"
    @hide="onClose">
    <template #modal-header="{ close }">
      <div class="container-fluid">
        <div class="lesson-topbar row">
          <div class="lesson-topbar-session col-md-12 d-flex align-items-center">
            <i class="fas fa-cogs fa-2x mr-2"></i
            ><span class="mr-5">{{ `${$t('LNG_CONFIGURATION_WIZARD')}` }}</span>
            <a
              role="button"
              href="#"
              class="text-danger k-button k-bare k-button-icon ml-auto border-0"
              @click="close">
              <span class="k-icon k-i-close"></span>
            </a>
          </div>
        </div>
      </div>
    </template>
    <template #default>
      <b-form
        id="wf-form"
        key="wf-form"
        ref="wf-form"
        @submit.prevent="">
        <v-stepper
          ref="wizardStepper"
          v-model="currentStep"
          :steps="numOfSteps"
          class="mb-4" />
        <template v-if="currentStep === 1">
          <fieldset class="k-form-fieldset">
            <legend class="k-form-legend border-bottom">
              {{ $t('LNG_LICENSE_MANAGEMENT') }}
            </legend>
            <p>{{ $t('LNG_LICENSE_MANAGEMENT_TEXT') }}</p>
            <div class="row d-flex">
              <div class="col">
                <b-form-group
                  id="wf-license-number-group"
                  key="wf-license-number-group"
                  :label="$t('LNG_LICENCE_KEY')"
                  :description="$t('LNG_LICENCE_KEY_HINT')">
                  <b-input-group>
                    <b-form-input
                      id="wf-license-number"
                      key="wf-license-number"
                      ref="wfLicenseNumber"
                      v-model="license"
                      v-validate="{
                        required: true,
                        regex: /[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}/,
                        min: 19,
                        max: 19,
                      }"
                      name="wf-license-number"
                      type="text"
                      :formatter="formatLicenceKey"
                      data-vv-name="wf-license-number"
                      :data-vv-as="$t('LNG_LICENCE_KEY')"
                      data-vv-scope="wf-step-1"
                      :placeholder="$t('LNG_LICENCE_KEY_PLACEHOLDER')"
                      :state="validateState('wf-license-number', 'wf-step-1')" />
                    <b-input-group-append>
                      <b-button
                        variant="success"
                        @click="activateLicense">
                        <i class="fas fa-check"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback id="wf-license-number-feedback">
                    {{ errors.first('wf-license-number') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
          </fieldset>
        </template>
        <template v-if="currentStep === 2">
          <fieldset class="k-form-fieldset">
            <legend class="k-form-legend border-bottom">
              {{ $t('LNG_PERSONAL_INFORMATION') }}
            </legend>
            <p>{{ $t('LNG_PERSONAL_INFORMATION_TEXT') }}</p>
            <div class="row d-flex">
              <div class="col">
                <b-form-group
                  id="wf-phone-number-group"
                  key="wf-phone-number-group"
                  :label="$t('LNG_CELLPHONE')">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="fas fa-phone-alt"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      id="wf-phone-number"
                      key="wf-phone-number"
                      ref="wfPhonenUmber"
                      v-model="cellphone"
                      v-validate="{
                        required: true,
                      }"
                      name="wf-phone-number"
                      type="text"
                      :formatter="formatPhoneNumber"
                      data-vv-name="wf-phone-number"
                      :data-vv-as="$t('LNG_CELLPHONE')"
                      data-vv-scope="wf-step-2"
                      :placeholder="$t('LNG_CELLPHONE_PLACEHOLDER')"
                      :state="validateState('wf-phone-number', 'wf-step-2')" />
                  </b-input-group>
                  <b-form-invalid-feedback id="wf-license-number-feedback">
                    {{ errors.first('wf-license-number') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="wf-whatsapp-enabled-group"
                  key="wf-whatsapp-enabled-group"
                  :label="$t('LNG_WHATSAPP_ENABLED')"
                  :description="$t('LNG_WIZARD_WHATSAPP_HINT')">
                  <b-form-checkbox
                    id="wf-whatsapp-enabled"
                    key="wf-whatsapp-enabled"
                    ref="wfWhatsappEnabled"
                    v-model="isWhatsappEnabled"
                    name="wf-whatsapp-enabled"
                    switch>
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group
                  id="wf-app-time-start-group"
                  key="wf-app-time-start-group"
                  :label="$t('LNG_CALENDAR_START_TIME')">
                  <b-form-timepicker
                    id="wf-app-time-start"
                    key="wf-app-time-start"
                    ref="wfAppTimeStart"
                    v-model="startWorkTime"
                    v-validate="{ required: true }"
                    name="wf-app-time-start"
                    :minutes-step="15"
                    :locale="locale"
                    :label-close-button="$t('LNG_CLOSE')"
                    :label-no-time-selected="$t('LNG_NO_TIME_SELECTED')"
                    :data-vv-as="$t('LNG_CALENDAR_START_TIME')"
                    data-vv-scope="wf-step-2"
                    :state="validateState('wf-app-time-start', 'wf-step-2')"></b-form-timepicker>
                  <b-form-invalid-feedback id="wf-app-time-start-feedback">
                    {{ errors.first('wf-app-time-start') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="wf-app-time-end-group"
                  key="wf-app-time-end-group"
                  :label="$t('LNG_CALENDAR_END_TIME')">
                  <b-form-timepicker
                    id="wf-app-time-end"
                    key="wf-app-time-end"
                    ref="wfAppTimeEnd"
                    v-model="endWorkTime"
                    v-validate="{ required: true }"
                    name="wf-app-time-end"
                    :minutes-step="15"
                    :locale="locale"
                    :label-close-button="$t('LNG_CLOSE')"
                    :label-no-time-selected="$t('LNG_NO_TIME_SELECTED')"
                    :data-vv-as="$t('LNG_CALENDAR_END_TIME')"
                    data-vv-scope="wf-step-2"
                    :state="validateState('wf-app-time-end', 'wf-step-2')"></b-form-timepicker>
                  <b-form-invalid-feedback id="wf-app-time-end-feedback">
                    {{ errors.first('wf-app-time-end') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="wf-states-group"
                  key="wf-states-group"
                  :label="$t('LNG_STATES_OF_ACTIVITY')">
                  <b-form-checkbox-group
                    v-model="states"
                    :options="statesOptions"
                    :text-field="'label'"
                    switches
                    stacked></b-form-checkbox-group>
                </b-form-group>
                <b-form-group
                  id="wf-duration-group"
                  key="wf-duration-group"
                  :label="$t('LNG_CALENDAR_COURSE_DURATION')"
                  :description="$t('LNG_WIZARD_DURATION_HINT')">
                  <b-form-input
                    id="wf-duration"
                    key="wf-duration"
                    ref="wfDuration"
                    v-model="duration"
                    v-validate="{ required: true, decimal: 0, min_value: 1 }"
                    name="wf-duration"
                    type="number"
                    step="1"
                    min="1"
                    :data-vv-as="$t('LNG_CALENDAR_COURSE_DURATION')"
                    :placeholder="$t('LNG_CALENDAR_COURSE_DURATION_PLACEHOLDER')"
                    :state="validateState('wf-duration')"></b-form-input>
                  <b-form-invalid-feedback id="wf-duration-feedback">
                    {{ errors.first('wf-duration') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="wf-lessonprice-group"
                  key="wf-lessonprice-group"
                  :label="$t('LNG_DEFAULT_LESSON_PRICE')">
                  <b-form-input
                    id="wf-lessonprice"
                    key="wf-lessonprice"
                    ref="wfLessonprice"
                    v-model="lessonPrice"
                    v-validate="{ required: true, decimal: 1, min_value: 1 }"
                    name="wf-lessonprice"
                    type="number"
                    step="1"
                    min="1"
                    :data-vv-as="$t('LNG_DEFAULT_LESSON_PRICE')"
                    :placeholder="$t('LNG_DEFAULT_LESSON_PRICE_PLACEHOLDER')"
                    :state="validateState('wf-lessonprice')"></b-form-input>
                  <b-form-invalid-feedback id="wf-lessonprice-feedback">
                    {{ errors.first('wf-lessonprice') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="wf-email-confirmation-group"
                  key="wf-email-confirmation-group"
                  :label="$t('LNG_CONFIRMATION_EMAIL')"
                  :description="$t('LNG_WIZARD_CONFIRMATION_HINT')">
                  <b-form-checkbox
                    id="wf-email-confirmation"
                    key="wf-email-confirmation"
                    ref="wfEmailConfirmation"
                    v-model="isEmailConfirmation"
                    name="wf-email-confirmation"
                    switch>
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group
                  id="wf-sms-confirmation-group"
                  key="wf-sms-confirmation-group"
                  :label="$t('LNG_CONFIRMATION_SMS')"
                  :description="$t('LNG_WIZARD_CONFIRMATION_HINT')">
                  <b-form-checkbox
                    id="wf-sms-confirmation"
                    key="wf-sms-confirmation"
                    ref="wfSmsConfirmation"
                    v-model="isSmsConfirmation"
                    name="wf-sms-confirmation"
                    switch>
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group
                  id="wf-email-reminder-group"
                  key="wf-email-reminder-group"
                  :label="$t('LNG_EMAIL_REMINDER')"
                  :description="$t('LNG_WIZARD_REMINDER_EMAIL_HINT')">
                  <b-form-checkbox
                    id="wf-email-reminder"
                    key="wf-email-reminder"
                    ref="wfEmailReminder"
                    v-model="isEmailReminder"
                    name="wf-email-reminder"
                    switch>
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group
                  v-if="isEmailReminder"
                  id="wf-email-reminder-days-group"
                  key="wf-email-reminder-days-group"
                  :label="$t('LNG_EMAIL_REMINDER_DAYS')">
                  <b-form-input
                    id="wf-email-reminder-days"
                    key="wf-email-reminder-days"
                    ref="wfEmailReminderDays"
                    v-model="emailReminderDays"
                    v-validate="{ required: isEmailReminder, numeric: true }"
                    name="wf-email-reminder-days"
                    type="number"
                    :data-vv-as="$t('LNG_REMINDER_DAYS')"
                    :state="validateState('wf-email-reminder-days')"
                    min="1"></b-form-input>
                </b-form-group>
                <b-form-group
                  id="wf-sms-reminder-group"
                  key="wf-sms-reminder-group"
                  :label="$t('LNG_SMS_REMINDER')"
                  :description="$t('LNG_WIZARD_REMINDER_SMS_HINT')">
                  <b-form-checkbox
                    id="wf-sms-reminder"
                    key="wf-sms-reminder"
                    ref="wfSMSReminder"
                    v-model="isSMSReminder"
                    name="wf-sms-reminder"
                    switch>
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group
                  v-if="isSMSReminder"
                  id="wf-sms-reminder-days-group"
                  key="wf-sms-reminder-days-group"
                  :label="$t('LNG_SMS_REMINDER_DAYS')">
                  <b-form-input
                    id="wf-sms-reminder-days"
                    key="wf-sms-reminder-days"
                    ref="wfSMSReminderDays"
                    v-model="smsReminderDays"
                    v-validate="{ required: isSMSReminder, numeric: true }"
                    name="wf-sms-reminder-days"
                    type="number"
                    :data-vv-as="$t('LNG_REMINDER_DAYS')"
                    :state="validateState('wf-sms-reminder-days')"
                    min="1"></b-form-input>
                </b-form-group>
              </div>
            </div>
          </fieldset>
        </template>
        <template v-if="currentStep === 3">
          <b-overlay
            :show="false"
            spinner-variant="success"
            spinner-type="grow">
            <fieldset class="k-form-fieldset">
              <legend class="k-form-legend border-bottom">
                {{ $t('LNG_COMMUNICATIONS') }}
              </legend>
              <p>{{ $t('LNG_COMMUNICATIONS_TEXT') }}</p>
              <div class="row d-flex">
                <div class="col">
                  <b-form-group
                    id="wf-providers-group"
                    key="wf-providers-group"
                    v-if="!isIgnoreCommunicationsSettings"
                    :label="$t('LNG_MY_EMAIL_PROVIDER')">
                    <b-form-radio-group
                      id="wf-provider"
                      key="wf-provider"
                      ref="wfProvider"
                      v-model="provider"
                      name="wf-provider"
                      :options="providerOptions"
                      buttons
                      @change="setDefaultSMTPValues()"></b-form-radio-group>
                  </b-form-group>
                </div>
              </div>
              <legend
                class="k-form-legend border-bottom"
                v-if="displaySmtpSettings">
                {{ $t('LNG_SMTP_SETTINGS') }}
              </legend>
              <p v-if="displaySmtpSettings">{{ $t('LNG_SMTP_SETTINGS_TEXT') }}</p>
              <div
                class="row d-flex"
                v-if="displaySmtpSettings">
                <div class="col">
                  <!-- Email -->
                  <b-form-group
                    id="wf-username-group"
                    key="wf-username-group"
                    :label="$t('LNG_SMTP_EMAIL')"
                    :description="$t('LNG_SMTP_USERNAME_HINT')">
                    <b-form-input
                      id="wf-username"
                      key="wf-username"
                      ref="wfUsername"
                      v-model="smtpUsername"
                      v-validate="{ required: true }"
                      name="wf-username"
                      type="text"
                      :data-vv-as="$t('LNG_SMTP_EMAIL')"
                      :placeholder="$t('LNG_SMTP_USERNAME_PLACEHOLDER')"
                      :state="validateState('wf-username')">
                    </b-form-input>
                    <b-form-invalid-feedback id="wf-username-feedback">
                      {{ errors.first('wf-username') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <!-- Mot de passe -->
                  <b-form-group
                    id="wf-provider-password-group"
                    key="wf-provider-password-group">
                    <b-input-group>
                      <b-form-input
                        id="wf-provider-password"
                        key="wf-provider-password"
                        ref="msPassword"
                        v-model="password"
                        v-validate="{ required: true }"
                        name="wf-provider-password"
                        :type="showPassword ? 'text' : 'password'"
                        :data-vv-as="$t('LNG_PASSWORD')"
                        :placeholder="$t('LNG_PASSWORD_PLACEHOLDER')"
                        :state="validateState('wf-provider-password')"
                        autocomplete="off">
                      </b-form-input>
                      <b-input-group-append>
                        <b-button
                          variant="secondary"
                          @click="showPassword = !showPassword">
                          <i
                            v-if="!showPassword"
                            :class="['fas', 'fa-eye']"></i>
                          <i
                            v-else
                            :class="['fas', 'fa-eye-slash']"></i>
                        </b-button>
                      </b-input-group-append>
                      <b-form-invalid-feedback id="wf-provider-password-feedback">
                        {{ errors.first('wf-provider-password') }}
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                  <!-- Serveur -->
                  <b-form-group
                    id="wf-server-group"
                    key="wf-server-group"
                    :label="$t('LNG_SMTP_SERVER')"
                    :description="$t('LNG_SMTP_SERVER_HINT')">
                    <b-form-input
                      id="wf-server"
                      key="wf-server"
                      ref="wfServer"
                      v-model="smtpServer"
                      v-validate="{ required: true }"
                      name="wf-server"
                      type="text"
                      :data-vv-as="$t('LNG_SMTP_SERVER')"
                      :placeholder="$t('LNG_SMTP_SERVER_PLACEHOLDER')"
                      :state="validateState('wf-server')"></b-form-input>
                    <b-form-invalid-feedback id="wf-server-feedback">
                      {{ errors.first('wf-server') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <!-- Port -->
                  <b-form-group
                    id="wf-port-group"
                    key="wf-port-group"
                    :label="$t('LNG_SMTP_PORT')"
                    :description="$t('LNG_SMTP_PORT_HINT')">
                    <b-form-input
                      id="wf-port"
                      key="wf-port"
                      ref="wfPort"
                      v-model="smtpPort"
                      v-validate="{ required: true }"
                      name="wf-port"
                      type="number"
                      :data-vv-as="$t('LNG_SMTP_PORT')"
                      :placeholder="$t('LNG_SMTP_PORT_PLACEHOLDER')"
                      :state="validateState('wf-port')"></b-form-input>
                    <b-form-invalid-feedback id="wf-port-feedback">
                      {{ errors.first('wf-port') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <!-- S�curit� -->
                  <b-form-group
                    id="wf-security-group"
                    key="wf-security-group"
                    :label="$t('LNG_SMTP_SECURITY')"
                    :description="$t('LNG_SMTP_SECURITY_HINT')">
                    <b-form-radio-group
                      id="wf-security"
                      key="wf-security"
                      ref="wfSecurity"
                      name="wf-security"
                      v-model="smtpSecurity"
                      :options="securityOptions"
                      buttons></b-form-radio-group>
                  </b-form-group>
                </div>
              </div>
            </fieldset>
          </b-overlay>
          <b-alert
            :show="smtpErrors"
            variant="danger">
            <i class="fas fa-exclamation-triangle"></i
            ><span class="ml-2">{{ $t('LNG_SMTP_TEST_ERROR') }}</span>
          </b-alert>
          <b-alert
            :show="isIgnoreCommunicationsSettings"
            variant="warning">
            <i class="fas fa-exclamation-triangle"></i
            ><span class="ml-2">{{ $t('LNG_COMMUNICATIONS_SETTINGS_IGNORE_WARNING') }}</span>
          </b-alert>
        </template>
        <template v-if="currentStep === 4">
          <fieldset class="k-form-fieldset">
            <legend class="k-form-legend border-bottom">
              {{ $t('LNG_CALENDAR') }}
            </legend>
            <p>{{ $t('LNG_CALENDAR_TEXT') }}</p>
            <div class="row d-flex">
              <div class="col"></div>
            </div>
            <b-form-group
              id="wf-phonesync-group"
              key="wf-phonesync-group">
              <b-form-radio-group
                id="wf-phonesync"
                key="wf-phonesync"
                ref="wfPhonesync"
                v-model="isPhoneSync"
                name="wf-phonesync"
                :options="phoneSyncOptions"
                buttons
                @change="phoneSyncChanged()"></b-form-radio-group>
            </b-form-group>
            <b-form-group
              id="wf-phonetype-group"
              key="wf-phonetype-group"
              v-if="isPhoneSync">
              <b-form-radio-group
                id="wf-phonetype"
                key="wf-phonetype"
                ref="wfPhonetype"
                v-model="phoneType"
                name="wf-phonetype"
                :options="phoneTypeOptions"
                buttons></b-form-radio-group>
            </b-form-group>
            <div v-if="phoneType == 'android'">
              <div class="row d-flex justify-content-between">
                <div class="col">
                  <div class="d-flex align-items-center mt-2">
                    <i class="fab fa-android fa-2x mr-3"></i>
                    <span>
                      <b-link
                        href="https://play.google.com/store/apps/details?id=at.bitfire.davdroid"
                        target="_blank">
                        {{ $t('LNG_ANDROID_APP_TO_SETUP') }}
                      </b-link>
                    </span>
                  </div>
                  <div class="d-flex justify-content-center">
                    <img
                      src="@/assets/caldav-app-android.png"
                      width="250"
                      height="250" />
                  </div>
                </div>
              </div>
              <div class="container-fluid mt-3">
                <div class="row d-flex">
                  <div class="col d-flex">
                    <p class="font-weight-bolder">{{ $t('LNG_CALENDAR_URL_WIZARD') }}</p>
                    <p class="text-monospace ml-2">{{ selectedCalendarUrl }}</p>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="col d-flex">
                    <p class="font-weight-bolder">{{ $t('LNG_CALENDAR_USERNAME_WIZARD') }}</p>
                    <p class="text-monospace ml-2">{{ selectedCalendarUsername }}</p>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="col d-flex">
                    <p class="font-weight-bolder">{{ $t('LNG_CALENDAR_PASSWORD_WIZARD') }}</p>
                    <p class="text-monospace ml-2">{{ selectedCalendarPassword }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="phoneType == 'apple'">
              <b-list-group>
                <b-list-group-item v-html="$t('LNG_CALDAV_IOS_INSTRUCTIONS_1')"></b-list-group-item>
                <b-list-group-item v-html="$t('LNG_CALDAV_IOS_INSTRUCTIONS_2')"></b-list-group-item>
                <b-list-group-item v-html="$t('LNG_CALDAV_IOS_INSTRUCTIONS_3')"></b-list-group-item>
                <b-list-group-item
                  v-html="$t('LNG_CALDAV_IOS_INSTRUCTIONS_4_UNDER')"></b-list-group-item>
              </b-list-group>
              <div class="container-fluid mt-3">
                <div class="row d-flex">
                  <div class="col d-flex">
                    <p class="font-weight-bolder">{{ $t('LNG_CALENDAR_URL_WIZARD') }}</p>
                    <p class="text-monospace ml-2">{{ selectedCalendarUrl }}</p>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="col d-flex">
                    <p class="font-weight-bolder">{{ $t('LNG_CALENDAR_USERNAME_WIZARD') }}</p>
                    <p class="text-monospace ml-2">{{ selectedCalendarUsername }}</p>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="col d-flex">
                    <p class="font-weight-bolder">{{ $t('LNG_CALENDAR_PASSWORD_WIZARD') }}</p>
                    <p class="text-monospace ml-2">{{ selectedCalendarPassword }}</p>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </template>
        <template v-if="currentStep === 5">
          <fieldset class="k-form-fieldset">
            <legend class="k-form-legend border-bottom">
              {{ $t('LNG_LOGO') }}
            </legend>
            <p>{{ $t('LNG_LOGO_TEXT') }}</p>
            <div class="row d-flex">
              <div class="col">
                <b-form-group
                  id="wf-app-logo-group"
                  key="wf-app-logo-group"
                  :label="$t('LNG_APP_LOGO')">
                  <b-input-group>
                    <b-form-file
                      id="wf-app-logo"
                      key="wf-app-logo"
                      ref="wfAppLogo"
                      v-model="logoFile"
                      v-validate="{ mimes: ['image/*'], size: 1024 }"
                      name="wf-app-logo"
                      accept="image/*"
                      :data-vv-as="$t('LNG_APP_LOGO')"
                      :placeholder="$t('LNG_APP_LOGO_PLACEHOLDER')"
                      :state="validateState('wf-app-logo')"
                      @input="handleFileUpload"></b-form-file>
                    <b-input-group-append>
                      <b-button
                        variant="outline-danger"
                        @click="
                          isLogoCleared = true;
                          logoFile = [];
                        ">
                        <i :class="['fas', 'fa-trash']"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-text>{{ $t('LNG_APP_LOGO_HINT') }}</b-form-text>
                  <b-form-invalid-feedback force-show>
                    {{ isSizeInvalid ? $t('LNG_WARNING_LOGO_SIZE') : '' }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
          </fieldset>
        </template>
        <template v-if="currentStep === 6">
          <fieldset class="k-form-fieldset">
            <legend class="k-form-legend border-bottom">
              {{ $t('LNG_END_WIZARD_TITLE') }}
            </legend>
            <p>{{ $t('LNG_END_WIZARD_TEXT') }}</p>
            <div class="row d-flex">
              <div class="col"></div>
            </div>
          </fieldset>
        </template>
      </b-form>
    </template>
    <template #modal-footer>
      <div class="container-fluid">
        <div class="lesson-topbar row">
          <div
            class="lesson-topbar-session col-md-12 d-flex align-items-center justify-content-between">
            <div class="d-flex">
              <b-button
                v-if="currentStep != 6"
                variant="outline-danger"
                class="my-2 my-sm-0 fre-btn"
                @click.prevent="onCancel">
                <i class="fas fa-car-crash"></i
                ><span class="d-none d-sm-inline ml-2">{{ $t('LNG_CANCEL') }}</span>
              </b-button>
            </div>
            <div class="d-flex">
              <b-button
                v-if="currentStep > 1 && currentStep != 6"
                variant="outline-secondary"
                class="my-2 my-sm-0 ml-2"
                @click.prevent="previous"
                ><i class="fas fa-chevron-left mr-2"></i>{{ $t('LNG_BACK') }}</b-button
              >
              <b-button
                v-if="currentStep === 1"
                variant="outline-danger"
                class="my-2 my-sm-0 ml-2"
                @click.prevent="
                  hasLicense = false;
                  next();
                "
                >{{ $t('LNG_NO_LICENSE') }}</b-button
              >
              <b-button
                v-if="currentStep === 3 && !isIgnoreCommunicationsSettings"
                variant="outline-danger"
                class="my-2 my-sm-0 ml-2"
                @click.prevent="
                  isIgnoreCommunicationsSettings = true;
                  displaySmtpSettings = false;
                  provider = null;
                "
                >{{ $t('LNG_IGNORE_COMMUNICATIONS_SETTINGS') }}</b-button
              >
              <b-button
                v-if="currentStep === 3 && isIgnoreCommunicationsSettings"
                variant="outline-success"
                class="my-2 my-sm-0 ml-2"
                @click.prevent="isIgnoreCommunicationsSettings = false"
                >{{ $t('LNG_COMMUNICATIONS_SETTINGS') }}</b-button
              >
              <b-button
                v-if="currentStep === 4 || currentStep === 5"
                variant="outline-danger"
                class="my-2 my-sm-0 ml-2"
                @click.prevent="next(true)"
                >{{ $t('LNG_IGNORE_STEP') }}</b-button
              >
              <b-button
                v-if="
                  currentStep !== 6 &&
                  (currentStep !== 3 || (currentStep === 3 && isIgnoreCommunicationsSettings))
                "
                variant="success"
                class="my-2 my-sm-0 ml-2"
                @click.prevent="next"
                >{{ $t('LNG_NEXT') }}<i class="fas fa-chevron-right ml-2"></i
              ></b-button>
              <b-button
                v-if="currentStep === 3 && displaySmtpSettings"
                variant="success"
                class="my-2 my-sm-0 ml-2"
                @click.prevent="testSMTP"
                >{{ $t('LNG_TEST') }}</b-button
              >
              <b-button
                v-if="currentStep === 6"
                variant="success"
                class="my-2 my-sm-0 ml-2"
                @click.prevent="
                  $refs.wizardStepper.reset();
                  setWizard(false);
                  $refs.wizardWindow.hide();
                  deauthenticate();
                "
                >{{ $t('LNG_LOGOUT') }}</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { validateForm } from '@/mixins/validateForm';
import { onTypeFormatter } from '@/helpers/phoneNumber.js';

export default {
  name: 'WizardWindow',
  components: {
    vStepper: () => import('vue-stepper-component'),
  },
  mixins: [validateForm],
  data() {
    return {
      currentStep: 1,
      numOfSteps: 6,
      license: null,
      hasLicense: true,
      cellphone: null,
      startWorkTime: '06:00',
      endWorkTime: '19:00',
      states: [],
      statesOptions: [],
      isEmailConfirmation: false,
      isSmsConfirmation: false,
      isEmailReminder: false,
      emailReminderDays: 2,
      isSMSReminder: false,
      smsReminderDays: 2,
      isWhatsappEnabled: false,
      lessonPrice: null,
      duration: 45,
      provider: [],
      providerOptions: [
        { text: 'Bluewin', value: 'bluewin' },
        { text: 'Google', value: 'gmail' },
        { text: 'Infomaniak', value: 'infomaniak' },
        { text: 'Microsoft', value: 'microsoft' },
        { text: this.$t('LNG_OTHER'), value: 'other' },
      ],
      phoneSyncOptions: [
        { text: this.$t('LNG_YES'), value: 1 },
        { text: this.$t('LNG_NO'), value: 0 },
      ],
      isIgnoreCommunicationsSettings: false,
      showPassword: false,
      password: null,
      smtpUsername: null,
      smtpPort: 587,
      smtpSecurity: 0,
      smtpServer: null,
      securityOptions: [
        { text: this.$t('LNG_NONE'), value: 0 },
        { text: this.$t('LNG_SSL'), value: 1 },
        { text: this.$t('LNG_TLS'), value: 2 },
      ],
      smtpErrors: false,
      isPhoneSync: false,
      phoneType: null,
      phoneTypeOptions: [
        { text: this.$t('LNG_ANDROID'), value: 'android' },
        { text: this.$t('LNG_APPLE'), value: 'apple' },
      ],
      selectedCalendarUrl: '',
      selectedCalendarUsername: '',
      selectedCalendarPassword: '',
      displaySmtpSettings: false,
      logoFile: [],
      isLogoCleared: false,
      logoSrc: null,
    };
  },
  computed: {
    ...mapGetters(['locale', 'me']),
    isSizeInvalid() {
      return this.logoFile && this.logoFile.size > 1000000;
    },
  },
  methods: {
    ...mapActions(['setWizard', 'deauthenticate']),
    show() {
      this.axios
        .get('/person/wizardsettings')
        .then((response) => {
          this.isWhatsappEnabled = response.data.isWhatsappEnabled;
          this.cellphone = response.data.cellphone;
          this.startWorkTime = response.data.startWorkTime;
          this.endWorkTime = response.data.endWorkTime;
          this.states = response.data.states;
          this.isEmailConfirmation = response.data.isEmailConfirmation;
          this.isSmsConfirmation = response.data.isSmsConfirmation;
          this.isEmailReminder = response.data.isEmailReminder;
          this.emailReminderDays = response.data.emailReminderDays;
          this.isSMSReminder = response.data.isSMSReminder;
          this.smsReminderDays = response.data.smsReminderDays;
          this.lessonPrice = response.data.lessonPrice;
          this.duration = response.data.duration;
          this.smtpUsername = response.data.smtpUsername;
          this.smtpPort = response.data.smtpPort;
          this.smtpSecurity = response.data.smtpSecurity;
          this.smtpServer = response.data.smtpServer;
          this.$refs.wizardWindow.show();
        })
        .catch((error) => {
          this.$root.$emit('notification::show', {
            message:
              typeof error.response === 'undefined'
                ? this.$t('LNG_UNKOWN_FATAL_ERROR')
                : error.response.data.message,
            type: 'danger',
          });
        });
    },
    onShown() {
      this.loadStates();
      this.smtpUsername = this.me.username;
    },
    onClose() {
      this.$refs.wizardStepper.reset();
      this.setWizard(false);
    },
    onCancel() {
      this.$refs.wizardStepper.reset();
      this.setWizard(false);
      this.$refs.wizardWindow.hide();
    },
    onSubmit() {},
    next(ignore) {
      switch (this.currentStep) {
        case 1:
          this.$validator.validate('wf-step-1.*').then((valid) => {
            if (valid || !this.hasLicense) {
              this.$refs.wizardStepper.next();
            }
          });
          break;
        case 2:
          this.$validator.validate('wf-step-2.*').then((valid) => {
            if (valid) {
              this.$refs.wizardStepper.next();
            }
          });
          break;
        case 3:
          if (!this.isIgnoreCommunicationsSettings) {
            this.$validator.validate('wf-step-3.*').then((valid) => {
              if (valid) {
                this.$refs.wizardStepper.next();
              }
            });
          } else {
            this.$refs.wizardStepper.next();
          }
          break;
        case 4:
          this.$validator.validate('wf-step-4.*').then((valid) => {
            if (valid || ignore) {
              this.$refs.wizardStepper.next();
            }
          });
          break;
        case 5:
          this.$validator.validate('wf-step-5.*').then((valid) => {
            if (valid || ignore) {
              //this.$refs.wizardStepper.next();
              this.saveSettings();
            }
          });
          break;
        default:
          break;
      }
    },
    previous() {
      if (this.currentStep === 2 && !this.hasLicense) {
        // if we go back, we reset the license value
        this.hasLicense = true;
        this.$refs.wizardStepper.previous();
      } else {
        this.$refs.wizardStepper.previous();
      }
    },
    formatLicenceKey(license) {
      let value = license.replace(/-/g, '').toUpperCase();
      const len = value.length;

      if (len >= 4 && len < 8) {
        value = value.replace(/(\w{4})/, '$1-');
      } else if (len >= 8 && len < 12) {
        value = value.replace('-', '').replace(/(\w{4})(\w{4})/, '$1-$2-');
      } else if (len >= 12 && len < 16) {
        value = value.replace('-', '').replace(/(\w{4})(\w{4})(\w{4})/, '$1-$2-$3-');
      } else {
        value = value.replace('-', '').replace(/(\w{4})(\w{4})(\w{4})(\w{4})/, '$1-$2-$3-$4');
      }

      return value;
    },
    activateLicense() {},
    loadStates() {
      this.axios
        .get('/person/states')
        .then((response) => {
          this.statesOptions = response.data.data;
        })
        .catch((error) => {
          this.$root.$emit('notification::show', {
            message:
              typeof error.response === 'undefined'
                ? this.$t('LNG_UNKOWN_FATAL_ERROR')
                : error.response.data.message,
            type: 'danger',
          });
        });
    },
    formatPhoneNumber(value) {
      return onTypeFormatter(value);
    },
    testSMTP() {
      const data = {};
      data.server = this.smtpServer;
      data.port = this.smtpPort;
      data.security = this.smtpSecurity;
      data.username = this.smtpUsername;
      data.password = this.password;
      this.smtpErrors = false;
      this.$root.$emit('spinner::show', { text: this.$t('LNG_VALIDATING_DATA') });
      this.axios
        .post('communication/testprovider', data)
        .then(() => {
          this.$refs.wizardStepper.next();
        })
        .catch(() => {
          this.smtpErrors = true;
        })
        .finally(() => {
          this.$root.$emit('spinner::hide');
        });
    },
    setDefaultSMTPValues() {
      switch (this.provider) {
        case 'bluewin':
          this.smtpPort = 465;
          this.smtpSecurity = 1;
          this.smtpServer = 'smtpauths.bluewin.ch';
          this.displaySmtpSettings = true;
          break;
        case 'gmail':
          this.smtpPort = 587;
          this.smtpSecurity = 2;
          this.smtpServer = 'smtp.gmail.com';
          this.displaySmtpSettings = true;
          break;
        case 'infomaniak':
          this.smtpPort = 465;
          this.smtpSecurity = 2;
          this.smtpServer = 'mail.infomaniak.com';
          this.displaySmtpSettings = true;
          break;
        case 'microsoft':
          this.smtpPort = 587;
          this.smtpSecurity = 2;
          this.smtpServer = 'smtp.office365.com';
          this.displaySmtpSettings = true;
          break;
        case 'other':
          this.smtpPort = null;
          this.smtpSecurity = null;
          this.smtpServer = null;
          this.displaySmtpSettings = true;
          break;
        default:
          this.displaySmtpSettings = false;
      }
    },
    phoneSyncChanged() {
      if (!this.isPhoneSync) {
        this.next();
      } else {
        this.axios({
          method: 'GET',
          url: '/person/principalcaldavsettings',
        })
          .then((response) => {
            this.selectedCalendarUrl = response.data.data.url;
            this.selectedCalendarUsername = response.data.data.username;
            this.selectedCalendarPassword = response.data.data.password;
          })
          .catch((error) => {
            this.$root.$emit('notification::show', {
              message:
                typeof error.response === 'undefined'
                  ? this.$t('LNG_UNKOWN_FATAL_ERROR')
                  : error.response.data.message,
              type: 'danger',
            });
          });
      }
    },
    saveSettings() {
      let formData = new FormData();
      formData.append('logo', this.logoFile);
      let payload = JSON.stringify({
        licence: this.license,
        cellphone: this.cellphone,
        whatsapp: this.isWhatsappEnabled,
        start: this.startWorkTime,
        end: this.endWorkTime,
        states: this.states,
        duration: this.duration,
        price: this.lessonPrice,
        confirmationE: this.isEmailConfirmation,
        confirmationS: this.isSmsConfirmation,
        reminderE: this.isEmailReminder,
        reminderS: this.isSMSReminder,
        reminderEDays: this.emailReminderDays,
        reminderSDays: this.smsReminderDays,
        smtpUser: this.smtpUsername,
        smtpPassword: this.password,
        smtpServer: this.smtpServer,
        smtpPort: this.smtpPort,
        smtpSecurity: this.smtpSecurity,
      });
      formData.append('payload', payload);

      this.$root.$emit('spinner::show', { text: this.$t('LNG_VALIDATING_DATA') });
      this.axios({
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        method: 'POST',
        url: `person/savewizardsettings`,
        data: formData,
      })
        .then(() => {
          // Afficher un message et d�connecter l'utilisateur
          this.$refs.wizardStepper.next();
        })
        .catch(() => {
          // TODO Afficher le message d'erreur
        })
        .finally(() => {
          this.$root.$emit('spinner::hide');
        });
    },
    handleFileUpload(event) {
      if (event) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.logoSrc = e.target.result;
        };
        reader.readAsDataURL(event);
      }
    },
  },
};
</script>
